import { createAllActions } from '@api/createRequestStore';
import * as types from './types';

const { init, fetching, createFetchingSuccess } = createAllActions(types.SCOPE);

const fetchMetricData = (metricName) => ({
  type: types.FETCH_DATA,
  metricName
});

const initMetric = ({ metric }) => ({
  type: types.INIT_METRIC,
  metric
});

const setupMetric = ({ metric, metricStore }) => ({
  type: types.SETUP_METRIC,
  metric,
  metricStore,
});

const setResponse = ({ metric, response }) => ({
  type: types.SET_RESPONSE,
  metric,
  response,
});

const setError = ({ metric, errorMsg, errorCode }) => ({
  type: types.SET_ERROR,
  metric,
  errorMsg,
  errorCode
});

const setFetching = ({ metric, isFetching }) => ({
  type: types.SET_FETCHING,
  metric,
  isFetching,
});

const setChartData = ( { metric, chartData } ) => ({
  type: types.SET_CHART_DATA,
  metric,
  chartData
});

const setTotalValue = ( { metric, metricValue } ) => ({
  type: types.SET_TOTAL_VALUE,
  metric,
  metricValue
});

export {
  init,
  fetching,
  createFetchingSuccess,
  fetchMetricData,
  initMetric,
  setupMetric,
  setResponse,
  setError,
  setFetching,
  setChartData,
  setTotalValue
};
